import Vue from 'vue';
import store from '@/lib/store';
import FieldList from './components/FieldList';

export default function() {
  const fieldList = new Vue({
    el: '#field-list',
    name: 'FieldListApp',
    components: {
      FieldList
    },
    store
  });

  $(document).one('pjax:end', () => {
    fieldList.$destroy();
  });
}
